
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3106"}},[_c('path',{attrs:{"data-name":"Path 2218","d":"M17.784 10.945L11.71 17.02a2.988 2.988 0 11-4.225-4.225l6.602-6.602a1.867 1.867 0 012.64 2.64l-5.545 5.546a.747.747 0 01-1.056-1.056l5.02-5.02-.795-.795-5.02 5.02a1.867 1.867 0 002.64 2.641l5.547-5.546a2.988 2.988 0 00-4.226-4.225L6.69 11.999a4.109 4.109 0 105.81 5.81l6.074-6.074z","fill":"currentColor"}})])])
          )
        }
      }
    